import AccessControl from './AccessControl.vue'

export default AccessControl
